<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KJHw9w/tc-custom/9781534354005.jpg?1716662257308" alt="This image is the cover for the book Antioch Vol. 1, Antioch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Antioch Vol. 1, Antioch
      </h1>
      <p class="bookDescription body article font2">
        <p>A king from a lost kingdom has a message for the modern world: duck! After years of waging war on a polluting oil corp, Antioch decides it's time to prove a point. He turns himself in, prepared to expose the company in court. But prison is dangerous, and Antioch may not live to speak the truth. Guest-starring Frontiersman! Collects ANTIOCH #1-4</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick Kindlon, Patrick Kindlon, Marco Ferrari
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?402e6c54